import { Spinner } from '@cimplico/components';
import { useWorkpaperProceduresNotes } from '../../../queries/use-workpaper-procedures-notes';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import ErrorSplashScreen from '../../../pages/ErrorSplashScreen';
import NotesList from '../notes/NotesList';
import plural from '../../../utilities/plural';

export default function WorkpaperProceduresNotes(): JSX.Element {
    const workpaperProceduresNotesQuery = useWorkpaperProceduresNotes();

    if (workpaperProceduresNotesQuery.isLoading) {
        return (
            <div className="absolute w-full h-[var(--remaining-screen-height)]">
                <div className="absolute top-1/3 left-1/2">
                    <Spinner size="sm" />
                </div>
            </div>
        );
    }

    if (workpaperProceduresNotesQuery.isError || !workpaperProceduresNotesQuery.isSuccess) {
        return <ErrorSplashScreen title="An error has occurred." smallScreen />;
    }

    const { notes } = workpaperProceduresNotesQuery.data;

    return (
        <div className="flex flex-col gap-4">
            <div className="flex gap-2 border-b border-gray-200 pb-4 -ml-4 -mr-8 pl-4 pr-8">
                <DocumentTextIcon className="w-6 h-6 text-gray-600" />
                <div className="flex gap-1 text-gray-800 items-center">
                    <p className="font-medium">{notes.length.toString()}</p>
                    <p className="">{plural(notes.length, 'note', 'notes')}</p>
                </div>
            </div>
            <NotesList notes={notes} />
        </div>
    );
}
